export const GRID_SCROLL_POSITION = 'GOAT.grid_scroll_position';

export const GRID_CELL_DATA_QA = 'grid_cell_product';

export const RESULTS_PER_PAGE = 24;

export const SORT = 'sort';

export const SORT_FILTER_BUTTON_CLASSNAME = 'filter-sort-button';

export const CATEGORY_LABEL_MAP = {
  Sneakers: 'All Sneakers',
  Apparel: 'All Apparel',
  Space: 'All Space',
  Collectibles: 'All Collectibles',
  Art: 'All Art',
};

export const SIZE_SORT = ['xxxs', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', '4xl'];

export const SIZE_GENDER = {
  men: 'US Men',
  women: 'US Women',
};

export const GENDER_SORT = ['men', 'women', 'youth', 'infant'];

export const FILTER_ENUMS = {
  AVAILABLE_NOW: 'is_in_stock',
  BRAND: 'brand',
  CATEGORY: 'web_groups',
  COLOR: 'color',
  CONDITION: 'product_condition',
  DISCOUNT_TAG: 'discount_tag',
  GENDER: 'gender',
  INSTANT_SHIP: 'instant_ship_lowest_price_cents',
  PRICE: 'lowest_price_cents',
  PRICE_BUCKET: 'lowest_price_cents_bucket',
  RELEASE_DATE: 'release_date',
  RECENTLY_RELEASED: 'recently_released',
  SIZE: 'size_converted',
  YEAR: 'release_date_year',
  YEAR_BUCKET: 'release_date_year_bucket',
};

export const CONSTRUCTOR_SERVICE_URL = 'https://ac.cnstrc.com';
